// Heals the "browser is subscribed but the server lost the record" desync:
// re-posts the existing browser push subscription to the backend (idempotent upsert).
import { api } from "@/lib/api";

export async function syncPushSubscription() {
  try {
    if (!("serviceWorker" in navigator) || !("PushManager" in window)) return false;
    const reg = await navigator.serviceWorker.getRegistration();
    if (!reg) return false;
    const sub = await reg.pushManager.getSubscription();
    if (!sub) return false;
    const raw = sub.toJSON();
    await api.post("/push/subscriptions", {
      endpoint: raw.endpoint,
      keys: raw.keys,
      expirationTime: raw.expirationTime || null,
      user_agent: navigator.userAgent,
    });
    return true;
  } catch {
    return false;
  }
}
